import "./styles/base.scss";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import MainLayout from "./layouts/MainLayout";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Admin from "./pages/Admin";
import Orders from "./pages/Orders";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return <Login />;

  const justLoggedIn = sessionStorage.getItem("justLoggedIn") === "1";

  if (justLoggedIn) {
    sessionStorage.removeItem("justLoggedIn");

    const isTargetRoute = location.pathname === "/products/merch";

    if (!isTargetRoute) {
      return <Navigate to="/products/merch" replace />;
    }
  }

  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();

  if (!user) return <Login />;

  if (user.email !== "admin@codaco.cz") {
    return <Navigate to="/products/merch" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <MainLayout>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Navigate to="/products/merch" replace />
                  </PrivateRoute>
                }
              />

              <Route
                path="/products"
                element={
                  <PrivateRoute>
                    <Navigate to="/products/merch" replace />
                  </PrivateRoute>
                }
              />

              <Route
                path="/products/:category"
                element={
                  <PrivateRoute>
                    <Products />
                  </PrivateRoute>
                }
              />

              <Route
                path="/products/:category/:subcategory"
                element={
                  <PrivateRoute>
                    <Products />
                  </PrivateRoute>
                }
              />

              <Route
                path="/product/:id"
                element={
                  <PrivateRoute>
                    <ProductDetail />
                  </PrivateRoute>
                }
              />

              <Route
                path="/cart"
                element={
                  <PrivateRoute>
                    <Cart />
                  </PrivateRoute>
                }
              />

              <Route
                path="/checkout"
                element={
                  <PrivateRoute>
                    <Checkout />
                  </PrivateRoute>
                }
              />

              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <Admin />
                  </PrivateRoute>
                }
              />

              <Route
                path="/admin/orders"
                element={
                  <PrivateRoute>
                    <AdminRoute>
                      <Orders />
                    </AdminRoute>
                  </PrivateRoute>
                }
              />

              <Route
                path="/root"
                element={
                  <PrivateRoute>
                    <h1>Root panel</h1>
                  </PrivateRoute>
                }
              />
            </Routes>
          </MainLayout>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
